import Card from 'antd/lib/card'
import { BlockComponentFactory } from 'shared/express-interface/blocks-core/BlockFactory'
import { ReactElement } from 'react'
import styles from './CardBlock.module.less'

export type CardBlockProps = {
    title?: string
    content?: string
    children?: ReactElement
}

export const CardBlockComponent = BlockComponentFactory.createBlockComponent<CardBlockProps>(
    props => {
        const { title, children } = props
        return (
            <Card data-testid="card-block">
                <Card.Meta
                    title={title ?? 'OUTPUT'}
                    data-testid="card-meta"
                    className={styles['card-block-meta']}
                />
                {children}
            </Card>
        )
    }
)
